import { get } from 'lodash';

const root = state => get(state, 'TransferOrderState.transferOrderList');

export const getTransferOrderListData = state =>
  get(root(state), 'transferOrderListData', []);
export const getTransferOrderListDataError = state =>
  get(root(state), 'transferOrderListDataError', null);
export const getLoading = state => get(root(state), 'loading', false);
export const getPrintLoading = state => get(root(state), 'printLoading', false);
export const getPrintLoadingError = state =>
  get(root(state), 'printLoadingError', null);
export const getFromDateMax = state => get(root(state), 'fromDateMax', null);
export const getToDateMin = state => get(root(state), 'toDateMin', null);
export const getPrintData = state => get(root(state), 'printData', '');



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/transfer/state/TransferOrderList/selectors.js